module.exports = __webpack_public_path__ + "img/eagleScrn3.6db6d195.png";